import React, { useState } from 'react'
import CurrentOrder from '../CurrentOrder/CurrentOrder'
import PastOrders from '../PastOrders/PastOrders'
import Style from './Tabs.module.css'
const Tabs = () => {
    const [checkedClass,setCheckdClass]=useState(false)
    const ClassHandler =()=>{
        setCheckdClass(false)
    }
    const ClassHandler2 =()=>{
        setCheckdClass(true)
    }
    let Content=null
    if(checkedClass) 
    {
        Content=<PastOrders/>
    }
    if(!checkedClass)
    {
        Content=<CurrentOrder/>
    }
    return (
        <div className={Style.PageHolder}>
            <header className={Style.TabsTitle}>
                <div className={checkedClass?Style.normal:Style.checked} onClick={ClassHandler}>سفارش های فعلی</div>
                <div className={checkedClass?Style.checked:Style.normal} onClick={ClassHandler2}>سفارش های قبلی</div>
            </header>
            {Content}
        </div>
    )
}

export default Tabs
